<template>
  <v-app>
    <v-app-bar
      app
      color="white">

      <!-- <v-app-bar-nav-icon :to="{ name: 'Landing' }">
        <slot>
          <v-img :src="require('./assets/logo-tud.png')" height="48" width="48" contain style="background-color: white"></v-img>
        </slot>
      </v-app-bar-nav-icon> -->

      <v-toolbar-title>
        Proiect I.S.S. – Întreprinderi sociale de succes
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn text :to="{ name: 'Landing' }" exact>
        <v-icon left>mdi-home</v-icon>
        Acasă
      </v-btn>
      <v-btn text :to="{ name: 'About' }" exact>
        <v-icon left>mdi-information</v-icon>
        Resurse
      </v-btn>
      <v-btn text :to="{ name: 'Login' }" exact v-if="!user">
        <v-icon left>mdi-account</v-icon>
        Cont
      </v-btn>
      <v-btn text :to="{ name: 'Account' }" exact v-if="user && user.role === 'aplicant'">
        <v-icon left>mdi-account</v-icon>
        Cont
      </v-btn>
      <v-btn text :to="{ name: 'AccountEvaluator' }" exact v-if="user && user.role === 'evaluator'">
        <v-icon left>mdi-account</v-icon>
        Cont
      </v-btn>
      <v-btn text :to="{ name: 'AccountAdmin' }" exact v-if="user && user.role === 'admin'">
        <v-icon left>mdi-account</v-icon>
        Panou control
      </v-btn>
      <v-btn text @click="logout" v-if="user">
        <v-icon left>mdi-logout</v-icon>
        Iesire
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <v-footer app padless>
      <v-container fluid>
        <v-row no-gutters>
          <v-col md="12" cols="12" class="text-center text-caption" style="display: flex; align-items: center; justify-content: center; flex-wrap: wrap">
            <a href="https://www.facebook.com/ISS-Intreprinderi-sociale-de-succes-107731347359838" target="_blank" class="text-decoration-none mr-2">
              <v-icon color="accent">mdi-facebook</v-icon>
            </a>
            Contact:
            <span style="white-space: nowrap">
              <v-icon small class="mx-2">mdi-email</v-icon> recrutaregt.addwise@gmail.com
            </span>
          </v-col>
          <!-- <v-col md="4" cols="12" class="text-right" style="display: flex; align-items: center; justify-content: flex-end">
            <span class="text-caption mr-2">powered by</span>
            <a href="https://tudconsult.ro/" target="_blank" class="text-subtitle-2 text-decoration-none">TUD Group | Verde Smart</a>
            <img :src="require('./assets/logo-tud.png')" height="18" width="18" class="ml-1">
          </v-col> -->
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({}),

  computed: {
    user () {
      return this.$store.getters.user
    }
  },

  methods: {
    async logout () {
      await this.$store.dispatch('logout')

      if (this.$route.name !== 'Landing') {
        this.$router.push({ name: 'Landing' })
      }
    }
  }
}
</script>

<style lang="stylus">
  .v-data-table__mobile-row__cell {
    height: 100%;
    overflow-y: auto;
  }

 .v-stepper, .v-stepper__header {
   box-shadow: none !important;
 }

 .v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .85;
  position: absolute;
  width: 100%;
}

.card-image {
  transition: all .2s ease-in-out
}
.card-image-hover {
  transform: scale(0.96)
  // height: 210px !important;
}
</style>
